<style scoped>
.load-4 .ring-1 {
    animation: loadingD 1.5s .3s cubic-bezier(.17, .37, .43, .67) infinite;
}

.load-4 {
    display: inline-block;

}

@keyframes loadingD {
    0 {
        transform: rotate(0deg);
    }

    50% {
        transform: rotate(180deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.clearfix::after {
    content: "";
    clear: both;
    display: inline-block;
}

.ring-1 {
    width: 10px;
    height: 10px;
    padding: 10px;
    border: 7px dashed #4b9cdb;
    border-radius: 100%;
}
</style>

<template>
<!-- <transition name="el-zoom-in-top"> -->
<div class="content-wrapper">
    <!-- Main content -->
    <section class="content">
        <!-- Default box -->
        <div class="box">
            <div class="box-header with-border">
                <h3 class="box-title">Contract</h3>
                <span id="downloadcon"></span>

            </div>
            <!-- <div v-if=isPreview>

                <div id="displaypdf" class="box-body">
                    <div style="margin:10px 0 0 0">
                        <button class="el-button el-button--success" @click="editPDF()">
                            Edit PDF
                        </button>
                        <button class="el-button el-button--success" @click="submit()">
                            <i class="el-icon-plus el-icon-left"></i>
                            Send Invite
                        </button>
                        <router-link to="/admin/AllPublisher/" class="el-button el-button--danger">
                            Cancel
                        </router-link>
                    </div>
                </div>
            </div> -->
            <div>
                <div class="box-body">

                    <div class="row" v-show="!isPreview">

                        <div class="col-sm-12 col-md-12">
                            <div class="col-sm-6">
                                <h5>Automatad Revenue Share</h5>

                                <el-input v-validate="'required|max_value:100'" data-vv-delay="1000" :class=" {'input': true , 'is-danger': errors.has('AutomatadRevenueShare') }" name="AutomatadRevenueShare" type="text" placeholder="Enter revenue share in percentage like 15%" v-model="agreemetformdata.revenue_share"></el-input>
                                <span v-show="errors.has('AutomatadRevenueShare')" class="help is-danger" style="color:red">{{ errors.first('AutomatadRevenueShare') }}</span>
                            </div>

                            <div class="col-sm-6">
                                <h5>Payment Duration</h5>

                                <el-input v-validate="'required|numeric'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('days') }" name="days" type="text" placeholder="Enter Number of days like 60 Days" v-model="agreemetformdata.period_to_send_rev_pub"></el-input>
                                <span v-show="errors.has('days')" class="help is-danger" style="color:red">{{ errors.first('days') }}</span>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12" style="margin-bottom: 20px;">
                            <div class="col-sm-6">
                                <h5> Payment Explainer Message </h5>

                                <el-input v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('paymentduration') }" name="paymentduration" type="text" placeholder="Enter Payment duration tax" v-model="agreemetformdata.rev_dist_clarity_example"></el-input>
                                <span v-show="errors.has('paymentduration')" style="color:red" class="help is-danger">{{ errors.first('paymentduration') }}</span>
                            </div>
                            <div class="col-sm-6">
                                <h5> Termination Duration </h5>

                                <el-input class="" v-validate="'required|numeric'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('terminationduration') }" name="terminationduration" type="text" placeholder="Termination Duration like 24 hours" v-model="agreemetformdata.termination_duration_for_pub"></el-input>
                                <span v-show="errors.has('terminationduration')" style="color:red" class="help is-danger">{{ errors.first('terminationduration') }}</span>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12" style="margin-bottom: 20px;">
                            <div class="col-sm-6">
                                <h5> Legal Publisher Name </h5>

                                <el-input data-vv-delay="1000" name="LegalPublisherName" type="text" placeholder="Enter Legal Publisher Name" v-model="agreemetformdata.LegalPublisherName"></el-input>

                            </div>
                        </div>
                    </div>

                    <agreement v-show="!isPreview" :revenuShare=agreemetformdata.revenue_share :periodToSendRevPub=agreemetformdata.period_to_send_rev_pub :example=agreemetformdata.rev_dist_clarity_example :terminationDuration=agreemetformdata.termination_duration_for_pub :LegalPublisherName=agreemetformdata.LegalPublisherName></agreement>

                    <div id="displaypdf" class="box-body">
                        <div style="margin:10px 0 0 0">
                            <button v-if="!isPreview" class="el-button el-button--success" @click="previewPDF()">

                                Preview Contract
                            </button>
                            <button v-else class="el-button el-button--success" @click="editPDF()">
                                Edit PDF
                            </button>

                            <button class="el-button el-button--success" @click="downloadcontract()">
                                <i class="fa fa-download"></i>
                                Download Contract
                            </button>
                            <!-- <a :href="downloadcontracturl" hidden id="dc" download>downloadcontract</a> -->

                            <div class="load-4" v-if="sendinginvite">

                                <div class="ring-1"></div>
                            </div>

                            <router-link to="/admin/Publishers/" class="el-button el-button--danger clearfix" style="float:right">
                                Cancel
                            </router-link>
                        </div>
                    </div>

                    <!-- <div id="resultofagree"></div> -->
                </div>
                <!-- /.box-body -->
            </div>
            <!-- /.box -->
        </div>
    </section>
    <!-- /.content -->
</div>
<!-- </transition> -->
</template>

<script>
import axios from 'axios';
import agreement from './Agreement.vue';
export default {
    components: {
        agreement
    },
    data() {
        return {
            agreemetformdata: {
                revenue_share: 15,
                period_to_send_rev_pub: 60,
                rev_dist_clarity_example: 'January will be sent 60 days from February 1',
                termination_duration_for_pub: 24,
                publisherId: 1,
                LegalPublisherName: ''
            },
            isPreview: false,
            agreementDoc: "",
            responsepdf: "",
            downloadurl: "",
            sendinginvite: false,
            iframobj: '',
            sentInviteScreenVisible: false,
            issentinvite: false,
            dowanloadcontractstatus: false,
            downloadcontracturl: ''
        }

    },
    created: function () {

        this.loaddownloadcontract();
    },
    methods: {

        loaddownloadcontract() {
            var api = BASE_URL + 'v1/download-contract/' + this.$route.params.id + '/';
            axios.get(api)
                .then(response => {
                    //console.log("res",response.data[0]);
                    if (response.data[0].status) {
                        //console.log("revenue_share",typeof response.data[0].revenue_share);
                        this.agreemetformdata.revenue_share = response.data[0].revenue_share;
                        this.agreemetformdata.period_to_send_rev_pub = response.data[0].period_to_send_rev_pub;
                        this.agreemetformdata.rev_dist_clarity_example = response.data[0].rev_dist_clarity_example;
                        this.agreemetformdata.termination_duration_for_pub = response.data[0].termination_duration_for_pub;
                        this.agreemetformdata.LegalPublisherName = response.data[0].legal_publisher_name;
                    }

                });
        },

        cancelInviteAction() {
            this.sentInviteScreenVisible = false;
        },
        downloadcontract() {

            var api = BASE_URL + 'v1/download-contract/' + this.$route.params.id + '/';

            var agreementDoc = document.getElementById("agreementform").innerHTML;
            //console.log("ag",agreementDoc);
            //console.log("lg",this.agreemetformdata.LegalPublisherName);

            //console.log("ag",agreementDoc);
            agreementDoc = agreementDoc.replace(/word-break: break-all;/g, "");

            let x = {
                'revenueShare': this.agreemetformdata.revenue_share,
                'periodToSendRevPub': this.agreemetformdata.period_to_send_rev_pub,
                'revDistClarityExample': this.agreemetformdata.rev_dist_clarity_example,
                'terminationDurationForPub': this.agreemetformdata.termination_duration_for_pub,
                'legalPublisherName': this.agreemetformdata.LegalPublisherName,
                'agreementDoc': agreementDoc
            }
            axios.post(api, x, {
                headers: {
                    'Content-Type': 'multipart/form-data; boundary=${data._boundary}',
                }
            }).then((response) => {

                //console.log(response)
                var b64 = response.data.encoded_string;
                var link = document.createElement('a');
                link.innerHTML = 'Download PDF file';
                link.download = response.data.fileName;
                link.href = 'data:application/octet-stream;base64,' + b64;
                link.click()

                // if (response) {
                //     var b64 = response.data;
                //     //console.log("b64 in dowanlod contract", response);

                //     this.downloadcontracturl = 'data:application/octet-stream;base64,' + b64;
                //     //console.log("downloadcontracturl", this.downloadcontracturl);

                //     if (this.downloadcontracturl.length != 0) {
                //         document.getElementById('dc').click();
                //     }

                // var spando=document.getElementById('downloadcon');
                // if(spando != 'undefined'){
                //     document.spando.appendChild(link);  
                // }

                this.$notify({
                    title: 'Success',
                    message: 'Successfully download',
                    type: 'success'
                });
                // this.sendinginvite = false;

                // }
            }, (error) => {
                // //console.log("Error")
                this.sendinginvite = false;

            })
        },
        submitinvite() {
            this.sentInviteScreenVisible = true;
        },

        submit() {
            this.sentInviteScreenVisible = false;
            this.sendinginvite = true;

            var api = BASE_URL + 'v1/send-invite-signnow/' + this.$route.params.id + '/';

            var agreementDoc = document.getElementById("agreementform").innerHTML;

            agreementDoc = agreementDoc.replace(/word-break: break-all;/g, "");

            let x = {
                'revenueShare': this.agreemetformdata.revenue_share,
                'periodToSendRevPub': this.agreemetformdata.period_to_send_rev_pub,
                'revDistClarityExample': this.agreemetformdata.rev_dist_clarity_example,
                'terminationDurationForPub': this.agreemetformdata.termination_duration_for_pub,
                'agreementDoc': agreementDoc
            }
            axios.post(api, x, {
                headers: {
                    'Content-Type': 'multipart/form-data; boundary=${data._boundary}',
                }
            }).then((response) => {

                if (response) {
                    this.$notify({
                        title: 'Success',
                        message: 'Successfully sent invite',
                        type: 'success'
                    });
                    this.sendinginvite = false;
                    this.$router.push('/admin/AllPublisher/')

                }
            }, (error) => {
                // //console.log("Error")
                this.sendinginvite = false;

            })
        },
        editPDF() {
            // //console.log("Editiiinggg")
            this.isPreview = false;
            var ifram = document.getElementById(this.iframobj);
            // //console.log("@@ifram", ifram);
            this.iframobj.style.display = "none";
        },
        previewPDF() {
            this.isPreview = true;
            var agreementDoc = document.getElementById("agreementform").innerHTML;

            let x = {

                'revenueShare': this.agreemetformdata.revenue_share,
                'periodToSendRevPub': this.agreemetformdata.period_to_send_rev_pub,
                'revDistClarityExample': this.agreemetformdata.rev_dist_clarity_example,
                'terminationDurationForPub': this.agreemetformdata.termination_duration_for_pub,
                'agreementDoc': agreementDoc

            }
            axios.post(BASE_URL + 'v1/pdf-preview/', x, {
                headers: {
                    'Content-Type': 'multipart/form-data; boundary=${data._boundary}',
                }
            }).then((response) => {
                var b64 = response.data
                // //console.log("@@@@@@@@@call");
                this.iframobj = document.createElement('iframe');
                // //console.log("iframobj", this.iframobj);
                this.iframobj.style.width = '100%';
                this.iframobj.style.height = '842pt';
                this.iframobj.type = 'application/pdf';
                this.iframobj.src = 'data:application/pdf;base64,' + b64;

                document.getElementById("displaypdf").prepend(this.iframobj)

            }, (error) => {
                // //console.log("Error")
            })
        },
    }
}
</script>

<style scoped>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.payment-textbox {
    width: 250px;
}

.el-select {
    display: block;
}

.content-wrapper .content {
    padding-top: 95px;
}

button[disabled=disabled],
button:disabled {
    background-color: rgba(200, 200, 200, 2.3);
    cursor: not-allowed;
    border-color: rgba(200, 200, 200, 2.3);
}
</style>



// WEBPACK FOOTER //
// PaymentForm.vue?19d7e79c